import type { NotificationStateRepository } from '@/features/notifications/domain/repository/notification-repository';
import { supabase } from '@/shared/infrastructure/supabase/client';

export const browserNotificationStateRepository: NotificationStateRepository = {
  async markAsRead(id, readAt) {
    const { error } = await supabase.from('notifications').update({ read_at: readAt }).eq('id', id);

    if (error) {
      console.error('Error al marcar notificación como leída:', error);
      throw error;
    }
  },

  async markAllAsRead(locationId, readAt) {
    const { error } = await supabase
      .from('notifications')
      .update({ read_at: readAt })
      .eq('location_id', locationId)
      .is('read_at', null);

    if (error) {
      console.error('Error al marcar todas como leídas:', error);
      throw error;
    }
  },
};
